import { Button } from '@purpur/library';
import styled, { css } from 'styled-components';

import { purpurFocus } from '@telialt/common-theme/src/mixins';
import {
    getPurpurBorder,
    getPurpurColor,
    getPurpurSpacing,
    getPurpurTypography,
    purpurMedia,
} from '@telialt/common-theme/src/purpurSelectors';

import { SpinnerWrapper } from '../SearchInput/SearchInput.styles';

export const InputWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 100%;
    height: 100%;

    ${purpurMedia('lg')`
        margin-left: auto;
        max-width: 41.25rem;
        width: 100%;
    `};
`;

export const OpenButton = styled(Button)`
    color: inherit;
    display: flex;
    border: 0;
    padding: 0;
    background-color: transparent;
`;

export const SearchButton = styled.button`
    border: 0;
    padding: 0;
    background-color: transparent;
    position: absolute;
    height: 1.5rem;
    right: ${getPurpurSpacing('300')};
    top: 50%;
    transform: translateY(-50%);

    ${purpurMedia('lg')`
        left: ${getPurpurSpacing('300')};
        right: auto;
    `};

    ${purpurFocus()};
`;

export const ClearButton = styled.button`
    display: none;

    ${purpurMedia('lg')`
        border: 0;
        padding: 0;
        background-color: transparent;
        position: absolute;
        height: 1.5rem;
        right: ${getPurpurSpacing('300')};
        top: 50%;
        transform: translateY(-50%);
        display: block;
    `};

    ${purpurFocus()};
`;

export const CloseButton = styled.button`
    display: none;
    font-weight: ${getPurpurTypography('weightMedium')};
    font-size: ${getPurpurTypography('scale100')};

    ${purpurMedia('lg')`
        border: 0;
        padding: 0;
        background-color: transparent;
        display: block;
        margin-left: auto;
    `};

    ${purpurFocus()};
`;

export const MobileCloseButton = styled.button`
    border: 0;
    padding: 0;
    background-color: transparent;
    position: absolute;
    height: 1.5rem;
    left: ${getPurpurSpacing('300')};
    top: 50%;
    transform: translateY(-50%);

    ${purpurMedia('lg')`
        display: none;
    `};

    ${purpurFocus()};
`;

export const SearchInput = styled.input.attrs({ type: 'search', name: 'telia-global-search' })<{ $isLoading: boolean }>`
    border-top: ${getPurpurBorder('widthXs')} solid ${getPurpurColor('gray400')};
    border-bottom: ${getPurpurBorder('widthXs')} solid ${getPurpurColor('gray400')};
    border-left: 0;
    border-right: 0;
    display: flex;
    width: 100%;
    max-height: auto;
    height: 100%;
    line-height: ${getPurpurTypography('lineHeightLoose')};
    padding: ${getPurpurSpacing('250')} 3.5rem;
    align-items: center;
    outline: none;
    font-size: ${getPurpurTypography('scale100')};
    background: none;

    &:active,
    &:focus,
    &:hover {
        outline: ${getPurpurBorder('widthSm')} solid ${getPurpurColor('purple550')};
        outline-offset: -${getPurpurBorder('widthSm')};
        border-color: transparent;
    }

    ${purpurMedia('lg')`
        border: none;
        border-radius: ${getPurpurBorder('radiusMd')};
        padding: ${getPurpurSpacing('200')} ${getPurpurSpacing('800')};
        width: 100%;
        height: auto;
        max-height: 4rem;

        &:hover {
            outline: ${getPurpurBorder('widthSm')} solid ${getPurpurColor('purple800')};
        }

        &:active,
        &:focus,
        &:hover {
            outline-offset: -${getPurpurBorder('widthXs')};
        }
    `};

    &:placeholder-shown ~ ${ClearButton} {
        display: none;
    }

    &:not(:placeholder-shown) {
        ${({ $isLoading }) =>
            $isLoading &&
            css`
                ${purpurMedia('sm')`
                    padding-right: 5.6rem;
                `}
                ${purpurMedia('md')`
                    padding-right: 6.25rem;
                `}
            `}
    }

    &:placeholder-shown ~ ${SpinnerWrapper} {
        ${purpurMedia('lg')`
            right: ${getPurpurSpacing('300')};
        `}
    }

    & ~ ${SpinnerWrapper} {
        top: ${getPurpurSpacing('250')};
    }

    &::-webkit-search-cancel-button,
    #search-clear {
        display: none;
    }
`;
